/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react';
import { GetUserTags as GET_USER_TAGS } from 'graphqlDocuments/queries';
import { useQuery } from '@apollo/client';
import { US_BANK_ACTIVE_TAG, US_BANK_ALLOWED_TAG, US_BANK_RESTRICTED_TAG } from '@constants';

type Chameleon = {
  identify: (id: string, props: object) => void;
};
type WindowWithChameleon = Window & {
  chmln?: Chameleon;
};

export default function useValidUserForUSBank() {
  const { data, loading, error } = useQuery(GET_USER_TAGS, {
    fetchPolicy: 'cache-first',
  });

  useEffect(() => {
    if (data?.me && (window as WindowWithChameleon).chmln) {
      (window as WindowWithChameleon).chmln?.identify(data.me.id, {
        virtualAccountActive: data.me.tags?.includes(US_BANK_ACTIVE_TAG),
      });
    }
  }, [data?.me]);

  if (loading || error) {
    return { isAllowed: undefined, isRestricted: undefined, loading, error };
  }

  return {
    isAllowed: data?.me?.tags.includes(US_BANK_ALLOWED_TAG),
    isRestricted: data?.me?.tags.includes(US_BANK_RESTRICTED_TAG),
    loading,
    error,
  };
}
